import { ApiError, type ConfiguratorSession, createBookingSession, getBookingSession } from '@platform/api';
import { queryOptions } from '@tanstack/react-query';
import { readStoredSessionId, storeSessionId } from './configuratorSession.storage';

async function createSession(signal?: AbortSignal): Promise<ConfiguratorSession> {
  const { data } = await createBookingSession({ body: { entryContext: 'OPEN_NEW' }, signal, throwOnError: true });
  storeSessionId(data.id);
  return data;
}

export async function loadOrCreateSession(signal?: AbortSignal): Promise<ConfiguratorSession> {
  const id = readStoredSessionId();
  if (id) {
    try {
      const { data } = await getBookingSession({ path: { id }, signal, throwOnError: true });
      return data;
    } catch (error) {
      // 404 = the stored session expired server-side; fall through and start a new one.
      if (!(error instanceof ApiError) || error.status !== 404) {
        throw error;
      }
    }
  }
  return createSession(signal);
}

export function getBookingSessionQueryOptions() {
  return queryOptions({
    queryKey: ['booking', 'session'] as const,
    queryFn: ({ signal }) => loadOrCreateSession(signal),
    staleTime: Number.POSITIVE_INFINITY,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}
